var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Actions, ofActionDispatched, Select, Store } from '@ngxs/store';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DRIVE_ENTRY_FULL_PERMISSIONS } from '../../permissions/drive-entry-permissions';
import { ResetState, SetInitialUsers, ShareDialogState, ShareEntries, ShareEntriesFailed } from '../state/share-dialog.state';
import { FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
var ShareDialogComponent = /** @class */ (function () {
    function ShareDialogComponent(dialogRef, store, actions$) {
        this.dialogRef = dialogRef;
        this.store = store;
        this.actions$ = actions$;
        this.destroyed$ = new Subject();
        this.errors = new BehaviorSubject({});
        this.resetModel();
        this.store.dispatch(new SetInitialUsers());
        this.bindToShareError();
        this.bindToShareModel();
    }
    ShareDialogComponent.prototype.ngOnDestroy = function () {
        this.store.dispatch(new ResetState());
        this.destroyed$.next();
        this.destroyed$.complete();
    };
    ShareDialogComponent.prototype.share = function () {
        var _this = this;
        var payload = {
            emails: this.shareModel.emails.value,
            permissions: this.shareModel.permissions,
        };
        this.store.dispatch(new ShareEntries(payload)).subscribe(function () {
            _this.setErrorMessages();
            _this.resetModel();
        });
    };
    ShareDialogComponent.prototype.resetModel = function () {
        this.shareModel = {
            emails: new FormControl([]),
            permissions: DRIVE_ENTRY_FULL_PERMISSIONS
        };
    };
    ShareDialogComponent.prototype.setErrorMessages = function (messages) {
        this.errors.next(messages || {});
    };
    ShareDialogComponent.prototype.bindToShareModel = function () {
        var _this = this;
        this.shareModel.emails.valueChanges
            .pipe(takeUntil(this.destroyed$))
            .subscribe(function () { return _this.setErrorMessages(); });
    };
    ShareDialogComponent.prototype.bindToShareError = function () {
        var _this = this;
        this.actions$.pipe(takeUntil(this.destroyed$), ofActionDispatched(ShareEntriesFailed)).subscribe(function (action) {
            _this.setErrorMessages(action.messages);
        });
    };
    __decorate([
        Select(ShareDialogState.loading),
        __metadata("design:type", Observable)
    ], ShareDialogComponent.prototype, "loading$", void 0);
    return ShareDialogComponent;
}());
export { ShareDialogComponent };
